import React, {useEffect} from "react";
//import { Link } from "gatsby";
import { useLocation } from "@reach/router"
import loadable from "@loadable/component"

import {Mini} from "@dadoagency/gatsby-plugin-trustpilot-widget";

// const {Mini} = loadable(() =>
//   import("@dadoagency/gatsby-plugin-trustpilot-widget")
// )

const ReviewRatings = (props) => {
    
    const location = useLocation();


    return(
        <div className="ratings">

            <Mini 
                language="en"
                culture="US"
                theme="dark"
                width="100%"
                height="110px"
                stars="1,2,3,4,5"
            />

        </div>
    )
}
export default ReviewRatings;